import React, { Component } from 'react';
import Clients from '../../components/css/dark/img/theme-images/clients.svg';
import Header from '../../components/Header';
import Sidebar from '../../components/Sidebar';
import $ from 'jquery';
import InfoPopup from '../../components/Distributor/Info';
import ReferralPopup from '../../components/Distributor/Referral';
import RepPopup from '../../components/Distributor/RepPopup';
import ResetPasswordPopup from '../../components/ChangePassword';
import ChangePassword from '../../components/css/dark/img/theme-images/change-password.svg';
import { userService } from '../../_services';
import { Redirect } from "react-router-dom";

class Tools extends Component {
    constructor(props) {
        super(props);
        try {
            this.state = {
                // users: null,
                dashboardListRendered: false,
                dashboardName: JSON.parse(localStorage.getItem('user')).dList[0].dashboardName,
                DisshowPopup: false,
                SubDisshowPopup: false,
                istoggleResetPasswordPopup: false,
                userdata: JSON.parse(localStorage.getItem('user')),
                InfoPopup: false,
                ReferralPopup: false,
                toggleRepPopup: false,
                Distributor: [],
                iscalled: false,
                HostURL: window.location.host
            };
        }
        catch (error) { }
    }

    componentDidUpdate(prevProp) {
        //if (this.state.Distributor.length == 0 && this.state.iscalled == false) {
        //    this.GetRepsDetail();
        //}
    }

    componentDidMount() {
        // document.title = 'Tools Page';
       // this.GetRepsDetail();
        setTimeout(function () {
            const hasScrollbar = document.body.scrollHeight > window.innerHeight;
            if (!hasScrollbar) {
                $('body').addClass('hide-scroller');
            }
        }, 300);
    }
    componentWillUnmount() {
        $('body').removeClass('hide-scroller');
    }
    GetRepsDetail() {
        try {
            let baseurl = "https://cnd.23byt.es/";
            if (this.state.userdata.wholesaler == "Avenelll") {
                baseurl = baseurl + 'avds/disinfo?Distributor=' + this.state.userdata.email;
            }
            else {
                baseurl = baseurl + 'ds/disinfo?Distributor=' + this.state.userdata.paramsname;
            }
            fetch(baseurl)
                .then(response => response.json())
                .then(data => {
                    this.setState({ Distributor: data, iscalled: true });
                });
        }
        catch (error) {
        }
    }

    InfoPopup() {
        if (this.state.InfoPopup === true) {
            $('.popup').removeClass('mfp-zoom-in');
            $('.popup').addClass('mfp-zoom-out');
            setTimeout(() => {
                this.setState({
                    InfoPopup: !this.state.InfoPopup,
                });
            }, 500)
        } else {
            this.setState({
                InfoPopup: !this.state.InfoPopup,
            });
        }
        $('body').toggleClass('modal-on');
    }

    ReferralPopup() {
        this.setState({
            ReferralPopup: !this.state.ReferralPopup,
        });
        $('body').toggleClass('modal-on');
    }
    toggleRepPopup() {
        var wname = this.state.userdata.wholesaler;
        if (this.state.toggleRepPopup === true) {
            $('.popup').removeClass('mfp-zoom-in');
            $('.popup').addClass('mfp-zoom-out');
            setTimeout(() => {
                this.setState({
                    toggleRepPopup: !this.state.toggleRepPopup
                });
            }, 500)
        } else {
            this.setState({
                toggleRepPopup: !this.state.toggleRepPopup
            });
        }
        $('body').toggleClass('modal-on');
    }
    toggleResetPasswordPopup() {
        var wname = this.state.userdata.wholesaler;
        if (this.state.istoggleResetPasswordPopup === true) {
            $('.popup').removeClass('mfp-zoom-in');
            $('.popup').addClass('mfp-zoom-out');
            setTimeout(() => {
                this.setState({
                    istoggleResetPasswordPopup: !this.state.istoggleResetPasswordPopup,
                    dashboardName: wname
                });
            }, 500)
        } else {
            this.setState({
                istoggleResetPasswordPopup: !this.state.istoggleResetPasswordPopup,
                dashboardName: wname
            });
        }
        $('body').toggleClass('modal-on');
    }

    handleCollapse = () => {
        if ($(".sidebar-section").hasClass("intro")) {
            $(".menu-text").css('width', 'auto');
            $(".sidebar-section").animate({
                width: 270 + 'px'
            }, 1000);
            $(".collapseButton").animate({
                left: 246 + 'px'
            }, 1000, function () {
                $(".collapseButton").removeClass('active');
                $(".tierMilestone .range").removeClass('active');
            });
            $(".tool-section").animate({
                marginLeft: 313 + 'px'
            }, 1000);
            $(".sidebar-section").removeClass('intro');
        } else {
            $(".sidebar-section").animate({
                width: 90 + 'px'
            }, 1000, function () {
                $(".menu-text").css('width', '0px');
            });
            $(".collapseButton").animate({
                left: 66 + 'px'
            }, 1000, function () {
                $(".collapseButton").addClass('active');
                $(".tierMilestone .range").addClass('active');
            });
            $(".tool-section").animate({
                marginLeft: 133 + 'px'
            }, 1000);
            $(".sidebar-section").addClass('intro');
        }
        var $head8 = $(".widget-iframe").contents().find("head");
        $head8.append($("<link/>",
            { rel: "stylesheet", href: "/table.css", type: "text/css" }));
    }
    render() {
        try {
            let usertype = userService.Get_User_Type();
            if (userService.Check_LoggedIn_Status() == 'Login') {
                return <Redirect to="/login" />
            }
            if (usertype.toLowerCase() == 'admin') {
                return <Redirect to='/pageNotFound' />
            }
            else if (usertype.toLowerCase() == 'wholesaler') {
                return <Redirect to='/pageNotFound' />
            }
        } catch (error) { }
        return (
            <div>
                <a href="javascript:void('0')" className="collapseButton" onClick={this.handleCollapse}>Collapse Button</a>
                <Header />
                <Sidebar />
                <div className="tool-section manage-icon">

                    <h2>Tools <span className="beta-link"><span className="beta">Beta</span></span></h2>

                    <ul>
                        <li onClick={this.InfoPopup.bind(this)}><div className="manage-content"><img src={Clients} alt="" />My Info<span className="arrow">&nbsp;</span></div></li>
                        {/* {
                            this.state.HostURL != "reporting.rxhacker.com" && this.state.userdata.wholesaler_Id != 61 ?
                                <li onClick={this.ReferralPopup.bind(this)}><div className="manage-content"><img src={Clients} alt="" />Referral<span className="arrow">&nbsp;</span></div></li> : null
                        }
                        */}
                        <li onClick={this.toggleRepPopup.bind(this)}><div className="manage-content"><img src={Clients} alt="" />Reps<span className="arrow">&nbsp;</span></div></li>
                        <li onClick={this.toggleResetPasswordPopup.bind(this)}><div className="manage-content"><img src={ChangePassword} alt="" />Reset Password<span className="arrow">&nbsp;</span></div></li>
                    </ul>
                    {
                        this.state.InfoPopup ?
                            <InfoPopup text='Rep Popup' calldata={"callonce"} closePopup={this.InfoPopup.bind(this)} /> : null
                    }
                    {
                         this.state.ReferralPopup ?
                            <ReferralPopup whName={this.state.userdata.wholesaler} text='Rep Popup' calldata={"callonce"} closePopup={this.ReferralPopup.bind(this)} /> : null
                    }
                    {
                        this.state.toggleRepPopup ?
                            <RepPopup text='Active & Inactive Reps' calldata={"callonce"} closePopup={this.toggleRepPopup.bind(this)} /> : null
                    }
                    {
                        this.state.istoggleResetPasswordPopup ?
                            <ResetPasswordPopup text='Reset Password' calldata={"callonce"} closeResetPasswordPopup={this.toggleResetPasswordPopup.bind(this)} /> : null
                    }
                </div>
            </div>
        )

    }

}
export default Tools;